import { FormGroup, ValidationErrors } from '@angular/forms';

export function contactInformationValidator() {
  return (contactInformationGroup: FormGroup): ValidationErrors | null => {
    const deskId = contactInformationGroup.get('deskId')?.value;
    const contactId = contactInformationGroup.get('contactId')?.value;

    if (deskId && !contactId) {
      contactInformationGroup.get('contactId')?.setErrors({
        required: true,
        message: 'Contact ID is required',
      });
    } else {
      contactInformationGroup.get('contactId')?.setErrors(null);
    }

    return null;
  };
}
